var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4973 10.008V19.008M11.4973 10.008L8.99728 12.008M11.4973 10.008L13.9973 12.008M4.53128 7.125C3.58549 7.36299 2.75915 7.93816 2.20753 8.74244C1.6559 9.54672 1.41696 10.5248 1.53558 11.4928C1.65421 12.4608 2.12224 13.3522 2.85174 13.9995C3.58124 14.6468 4.52201 15.0054 5.49728 15.008H6.49728",
    stroke: "#DDBA73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.3277 5.14553C14.9859 3.7921 14.1423 2.61927 12.9678 1.86479C11.7934 1.1103 10.376 0.830621 9.00297 1.08243C7.62996 1.33425 6.40406 2.09872 5.57378 3.22087C4.7435 4.34302 4.37098 5.7389 4.53172 7.12553C4.53172 7.12553 4.68472 8.00753 4.99772 8.50753",
    stroke: "#DDBA73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.4971 15.0078C17.2031 15.0073 17.901 14.8573 18.5449 14.5677C19.1888 14.278 19.7641 13.8553 20.2328 13.3273C20.7015 12.7993 21.0531 12.178 21.2645 11.5043C21.4758 10.8307 21.542 10.1199 21.4588 9.41876C21.3757 8.71764 21.1449 8.04208 20.7819 7.43655C20.4188 6.83103 19.9316 6.30926 19.3523 5.9056C18.773 5.50193 18.1149 5.22553 17.4211 5.09457C16.7273 4.96362 16.0136 4.98108 15.3271 5.14581L13.9971 5.50781",
    stroke: "#DDBA73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.2714f00bd6f7c1b13863c1b896415400.svg";
export { ForwardRef as ReactComponent };